// extracted by mini-css-extract-plugin
module.exports = {"error-message":"AuthInputFields_error-message__93PyP","errorMessage":"AuthInputFields_error-message__93PyP"};